var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0234 14.644C11.0234 13.7782 11.1286 13.0885 11.3389 12.5752C11.5492 12.0618 11.9326 11.5578 12.4893 11.063C13.0521 10.562 13.4263 10.1569 13.6118 9.84766C13.7974 9.53223 13.8901 9.20133 13.8901 8.85498C13.8901 7.80973 13.4077 7.28711 12.4429 7.28711C11.9852 7.28711 11.6172 7.42936 11.3389 7.71387C11.0667 7.99219 10.9245 8.37874 10.9121 8.87354H8.22168C8.23405 7.69222 8.61442 6.76758 9.36279 6.09961C10.1174 5.43164 11.144 5.09766 12.4429 5.09766C13.7541 5.09766 14.7715 5.41618 15.4951 6.05322C16.2188 6.68408 16.5806 7.5778 16.5806 8.73438C16.5806 9.26009 16.4631 9.75798 16.228 10.228C15.993 10.6919 15.5817 11.2083 14.9941 11.7773L14.2427 12.4917C13.7726 12.9432 13.5036 13.472 13.4355 14.0781L13.3984 14.644H11.0234ZM10.7544 17.4922C10.7544 17.0778 10.8936 16.7376 11.1719 16.4717C11.4564 16.1995 11.8182 16.0635 12.2573 16.0635C12.6965 16.0635 13.0552 16.1995 13.3335 16.4717C13.618 16.7376 13.7603 17.0778 13.7603 17.4922C13.7603 17.9004 13.6211 18.2375 13.3428 18.5034C13.0706 18.7694 12.7088 18.9023 12.2573 18.9023C11.8058 18.9023 11.4409 18.7694 11.1626 18.5034C10.8905 18.2375 10.7544 17.9004 10.7544 17.4922Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.3a4b80e9e91efc05ae8b57fbb6ed9522.svg";
export { ForwardRef as ReactComponent };